export default "__VITE_ASSET__B3MDI$6E__"